import moment from "moment";
import {getCourtDate} from '../common'
interface Action {
    payload: any,
    type: string,
    field: string,
    subfield?: string
    value?: { length?: number },
    validate: boolean,
}

const errors: {
    [key: string]: string
} = {
    date: "Please select a date time.",
    time: "Please select a date time.",
    county_time_zone: "Please select valid date for the case."
};

export default (data: any, action: Action) => {

    const newForm = {...data};
    const prop = newForm[action.field];
    const length = action?.value?.length || 0;

    if (prop) {
        action.value = action.value === ' ' ? '' : action.value;

        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }

        prop.error = (prop.added && !action.value && prop.required) || (prop.min && prop.min > length) ? errors[action.field] : null;
        prop.value = action.value;

    }

    if (newForm.time.value) {
        let date = moment(newForm.date.value);
        const h = moment(newForm.time.value).hours();
        const m = moment(newForm.time.value).minutes();
        const s = moment(newForm.time.value).seconds();
        const ms = moment(newForm.time.value).milliseconds();

        date.hours(h)
            .minutes(m)
            .seconds(s)
            .milliseconds(ms);

        newForm.date.value = moment(date).format('YYYY-MM-DDTHH:mm:ss');
        newForm.full_date.value = moment(date).format('YYYY-MM-DDTHH:mm:ss');
    }

    if (newForm.county_time_zone?.value) {
        const nDate = getCourtDate(newForm.county_time_zone.value);
        if (moment(newForm.full_date.value).toDate() < new Date(nDate)) {
            newForm.county_time_zone.error = errors.county_time_zone;
        } else {
            newForm.county_time_zone.error = null
        }
    }

    const vals = Object.values(newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);

    return {
        changed: true,
        valid: !newForm.county_time_zone.error && vals.length === valid.length,
        data: newForm,
    };

};
